import { Identifiers, IdentifierType } from "../../../core/internal/model/model"

export class InAppMessageIdentifierChecker {
  isIdentifierChanged(oldIdentifiers: Identifiers, newIdentifiers: Identifiers): boolean {
    const oldUserId = oldIdentifiers[IdentifierType.USER]
    const newUserId = newIdentifiers[IdentifierType.USER]
    if (oldUserId !== undefined && newUserId !== undefined) {
      return oldUserId !== newUserId
    }

    const oldDeviceId = oldIdentifiers[IdentifierType.DEVICE]
    const newDeviceId = newIdentifiers[IdentifierType.DEVICE]
    if (oldDeviceId !== undefined && newDeviceId !== undefined) {
      return oldDeviceId !== newDeviceId
    }

    return false
  }
}
